/**
 * What actually still works without a connection.
 *
 * The estimate engine and the client PDF are entirely client-side — the font is
 * embedded in the bundle and `generateClientOfferPDF` makes no network call — so
 * telling the contractor on site that a PDF needs a connection is simply false.
 * Only the photo analysis (Gemini) and saving to Firestore need the network.
 */

export const OFFLINE_CAPABILITY_MESSAGE =
  'Jesteś offline. Możesz uzupełnić dane wyceny i wygenerować PDF. ' +
  'Analiza zdjęć oraz zapis online będą dostępne po odzyskaniu połączenia.';

/** Shown next to the estimate itself, where the local draft is what got saved. */
export const OFFLINE_NETWORK_FEATURE_MESSAGE =
  'Analiza zdjęć i zapis online są chwilowo niedostępne. Robocza wycena została zapisana lokalnie.';

/** Features that genuinely stop working offline. */
export const OFFLINE_BLOCKED_FEATURES = ['vision', 'save'] as const;

/** Features that keep working offline and must never be announced as blocked. */
export const OFFLINE_AVAILABLE_FEATURES = ['estimate', 'pdf'] as const;

export type OfflineFeature =
  | (typeof OFFLINE_BLOCKED_FEATURES)[number]
  | (typeof OFFLINE_AVAILABLE_FEATURES)[number];

export function isFeatureAvailableOffline(feature: OfflineFeature): boolean {
  return (OFFLINE_AVAILABLE_FEATURES as readonly string[]).includes(feature);
}
